// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"f0c3c97f","239":"dac06248","299":"0831b842","453":"f88409ed","455":"7ac8d574","471":"da022dff","529":"eb688aa4","635":"e82f8c35","716":"cb25942b","821":"2b5cc8e9","977":"e9d662d1"}[chunkId] + ".chunk.js";
};